"use client";
import { useAuth } from "@/context/AuthContext";
import FlexSection from "@/partials/sections/Section/FlexSection";
import Link from "next/link";
import React from "react";

export default function MenubarAuth({ toggleDrawer }) {
  const { customer, logout } = useAuth();

  return (
    <FlexSection extraClass="absolute bottom-10 w-full flex-col">
      {!customer?._id ? (
        <>
          <div className="pb-4">
            <Link href={"/login"}>
              <button
                onClick={toggleDrawer}
                className="text-[#020202] text-base py-3 font-medium border border-[#020202] rounded-md w-full bg-none"
              >
                Login
              </button>
            </Link>
          </div>
          <Link href={"/member"}>
            <button
              onClick={toggleDrawer}
              className="bg-primary text-white w-full py-3 font-medium rounded-md"
            >
              Become a Member
            </button>
          </Link>
        </>
      ) : (
        <button
          onClick={logout}
          className="bg-primary text-white w-full py-3 font-medium rounded-md"
        >
          Logout
        </button>
      )}
    </FlexSection>
  );
}
